import EVENT_NAMES from "./eventConstants";
import SERVICE_NAMES from "./serviceConstants";

const EVENT_REGISTRY = {
	[EVENT_NAMES.LP_VIEW]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.FORM_CLICKED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.OTP_VERIFIED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.KYC_INITIATED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.KYC_COMPLETED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.KYC_FAILED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_PAYMENT_INITIATED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_PAYMENT_DONE]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_PAYMENT_FAILED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ONBOARDING_FORM_VISIT]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ONBOARDING_FORM_SUBMITTED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
	],
	[EVENT_NAMES.SHIPPING_RATE_CALCULATOR_VISIT]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ADD_ORDER_CLICKED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ORDER_PAYMENT_MODE_SELECTED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.BANNERS_CLICKED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.SHIP_NOW_INITIATED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ORDER_ADDED_SUCCESS]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_POPUP_VIEWED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_COUPON_ENTERED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_COUPON_FAILED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.DASHBOARD_PAGE_VISIT]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.SHIP_NOW_SUCCESS]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.LOW_BALANCE_NUDGED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.SIDE_NAVIGATION_CLICKED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.BUTTON_CLICKED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.HOME_PAGE_VISIT]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RECHARGE_POPUP_CTA_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CARGO_ONBOARDING_TOUR_V1]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CARGO_ONBOARDING_TOUR_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_SCREEN_VIEW]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_CTA_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_USER_TYPE_SELECTED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_FIELD_FILLED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_TC_ACCEPTED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_COMPLETED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ONBOARDING_BUSINESS_TYPE_SELECTED]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ONBOARDING_PRODUCT_CATEGORY_SELECTED]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.CANCEL_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_DECISION]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.LOGIN_VIEW]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.LOGIN_ERROR]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.LOGIN_DONE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PERSONA_INFO]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PERSONA_INFO_SWITCH]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RECHARGE_WALLET_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RECHARGE_DONE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RATE_API_FAILED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_SEARCH_USED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_FILTER_INTERACTED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_TICKET_HISTORY_TOGGLED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_CREATE_TICKET_OPENED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_CREATE_TICKET_INPUT]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_CANCEL_SHIPMENT]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_TICKET_CREATED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_TICKET_EDIT_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SUPPORT_TICKET_UPDATED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.NDR_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.NDR_FILTER_INTERACTED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.AWB_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.LABEL_URL_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.POD_URL_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SHIP_CHARGE_HISTORY_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REATTEMPT_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REATTEMPT_DECISION]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.BOOK_APPOINTMENT_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.BOOK_APPOINTMENT_DECISION]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SRCALC_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SRCALC_CALCULATE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SERVICE_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SERVICE_CHECK]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SERVICE_DOWNLOAD_LIST]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SERVICE_DOWNLOAD_PROCEED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PINCODE_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PINCODE_ZONE_DOWNLOAD]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RATE_CHART_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RATE_CHART_MODE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.INVOICES_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.INVOICES_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.INVOICES_DOWNLOAD_POD]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.BILLING_DOWNLOAD_WAYBILL]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.INVOICES_PAY_NOW]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REMITTANCE_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PASSBOOK_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CREDIT_NOTES_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CREDIT_NOTES_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PAYMENTS]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.LOCATION_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.DP_SELECTED]: [
		SERVICE_NAMES.POSTHOG,
		SERVICE_NAMES.MOENGAGE,
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.RESCHEDULE_PICKUP_INITIATED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RESCHEDULE_PICKUP_COMPLETED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.PICKUP_DATES_SELECTION_POPUP]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ECOD_PAGE_VIEWED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ECOD_PLAN_ACTIVATE_INITIATE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ECOD_PLAN_ACTIVATE_COMPLETE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ECOD_PLAN_DEACTIVATE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REMITTANCE_FILTER_INTERACTED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REMITTANCE_DOC_UPLOADED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REMITTANCE_CRF_DOWNLOADED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REMITTANCE_TAB_SWITCH]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REMITTANCE_FILE_DOWNLOAD]: [SERVICE_NAMES.GOOGLEANALYTICS],

	[EVENT_NAMES.KYC_INITIATED_EV2]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
		SERVICE_NAMES.MOENGAGE,
	],
	[EVENT_NAMES.RECHARGE_POPUP_VIEWED_EV2]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
		SERVICE_NAMES.MOENGAGE,
	],
	[EVENT_NAMES.ADD_ORDER_CLICKED_EV2]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
		SERVICE_NAMES.MOENGAGE,
	],
	[EVENT_NAMES.SRCALC_ADVANCE]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SRCALC_SHORT]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.REQUEST_CALL]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SCHEDULE_TRAINING]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.VIEW_VIDEO]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.BANNER_CLICKED]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_RESCHEDULE_PICKUP_INITIATED]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.CANCEL_RESCHEDULE_PICKUP_COMPLETED]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.CANCEL_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_DECISION_CLOSED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_DECISION_CANCELLED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RESCHEDULE_PICKUP_INITIATED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RESCHEDULE_PICKUP_COMPLETE_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.APPOINTMENT_SCHEDULE_INITIATED_V2]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.APPOINTMENT_SCHEDULE_DONE_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.APPOINTMENT_SCHEDULE_ERROR_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_RESCHEDULE_PICKUP_INITIATED_V2]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.CANCEL_RESCHEDULE_PICKUP_COMPLETE_V2]: [
		SERVICE_NAMES.GOOGLEANALYTICS,
	],
	[EVENT_NAMES.ALL_SHIPMENTS_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.NEW_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.READY_TO_SHIP_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.IN_TRANSIT_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.DELIVERED_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.RTO_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_REQUESTS_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ALL_TAB_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.EDIT_ORDER_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CLONE_ORDER_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CANCEL_ORDER_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.SHIP_NOW_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.GET_SUPPORT_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.CLONE_SHIPMENT_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.DOWNLOAD_LABEL_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.UPDATE_EWAYBILL_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.TRACK_SHIPMENT_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.TAKE_ACTION_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.DOWNLOAD_POD_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ORDER_ID_HPL_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.WAYBILL_HPL_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ADD_BULK_SHIPMENT_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.ADD_SINGLE_SHIPMENT_CLICKED_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
	[EVENT_NAMES.DOWNLOAD_MIS_V2]: [SERVICE_NAMES.GOOGLEANALYTICS],
};

export default EVENT_REGISTRY;
